import React from 'react';
import { Navigate, useOutlet } from 'react-router';

import VendorWrapper from '@components/vendorWrapper/VendorWrapper';
import AppTheme from '@core/AppTheme';
import '@core/store/appSlice/appSlice';
import { useAuth } from '@providers/authProvider';
import { UnsavedChangesProvider } from '@providers/unsavedChangesProvider';

const ProtectedRoute: React.FC = () => {
  const { user } = useAuth();
  const outlet = useOutlet();

  return user ? (
    <>
      <AppTheme isLogin={false} />
      <VendorWrapper>
        <UnsavedChangesProvider>{outlet}</UnsavedChangesProvider>
      </VendorWrapper>
    </>
  ) : (
    <Navigate to="/" />
  );
};
export default ProtectedRoute;
